import { requests } from "../../../api/agent"

export default {
	getHelps          : (params) => requests.getWithParams('/helpSection/getHelps', params),
	getOneHelp        : (params) => requests.getWithParams('/helpSection/getOneHelp', params),
	createHelp        : (params) => requests.post('/helpSection/createHelp', params),
	deleteHelp        : (params) => requests.getWithParams('/helpSection/deleteHelp', params),
	restoreHelp       : (params) => requests.getWithParams('/helpSection/restoreHelp', params),
	getHelpTags       : (params) => requests.getWithParams('/helpSection/getHelpTags', params),
	getActualHelpTags : (params) => requests.getWithParams('/helpSection/getActualHelpTags', params),
	updateHelpTag     : (params) => requests.put('/helpSection/updateHelpTag', params),
	createHelpTag     : (params) => requests.post('/helpSection/createHelpTag', params),
	deleteHelpTag     : (params) => requests.getWithParams('/helpSection/DeleteHelpTag', params),
	restoreHelpTag    : (params) => requests.getWithParams('/helpSection/RestoreHelpTag', params),
	updateHelp        : (params) => requests.put('/helpSection/updateHelp', params)
}